<ng-container *ngIf="operation$ | async as operation" [xOperation]="operation">
  <x-shop-dialog
    [heading]="'Order No: ' + this.data.order.number"
    [loading]="operation.status === 'loading'"
    (closeDialog)="closeDialog()"
    [subheading]="
      operation.status === 'loading'
        ? subheadingTranslations.loading
        : subheadingTranslations.download
    "
  >
    <x-shop-dialog-actions>
      <a
        mat-flat-button
        color="primary"
        xAction
        [href]="operation.data?.url"
        target="_blank"
        download
        [disabled]="operation.status === 'loading'"
        i18n="@@CallToAction.Download"
      >
        Download
      </a>
    </x-shop-dialog-actions>
  </x-shop-dialog>

  <x-shop-error-operation *xOperationError="let error" [error]="error"></x-shop-error-operation>
</ng-container>
